import { render, staticRenderFns } from "./User-profile.vue?vue&type=template&id=4df85c86&scoped=true&"
import script from "./User-profile.vue?vue&type=script&lang=js&"
export * from "./User-profile.vue?vue&type=script&lang=js&"
import style0 from "./User-profile.vue?vue&type=style&index=0&id=4df85c86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df85c86",
  null
  
)

export default component.exports